import app from './../index';
import Pageable from './../Pageable';

export default class KundenController {

	constructor () {
		this.page = 1;
		this.searchText = "";
		this.kunden = [];
		this.refresh();
	}

	refresh() {
		this.pageable = new Pageable(app.api.kunden);

		let params = {
			name: this.searchText
		};

		this.pageable.refresh(params);
	}
}



/** WEBPACK FOOTER **
 ** ./public/app/kunden/KundenController.js
 **/